<template>
  <div>
    <div class="select-payment" @click="selectPayment(selectedCard.card_index)">
      <div v-if="Object.keys(selectedCard).length > 0" class="has-payment">
        <img :src="selectedCard.card_org" class="ic-card" alt="">
        <span class="card-num">{{selectedCard.card_suffix | cardFilter}}</span>
      </div>
      <span v-else class="no-payment">{{gettext('请选择支付方式')}}</span>
      <i class="icon-right"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { couponPaymethodPopupCk } from '../../track'

export default {
  name: 'payBtn',
  data () {
    return {
      isShow: false,
      codeValue: ''
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    extraInfoList () {
      return this.$store.state.extraInfoList
    }
  },
  filters: {
    // 取卡号后4位
    cardFilter (card) {
      return String(card).slice(-4) || ''
    }
  },
  async mounted () {
    this.getGlobalInfo().then((data) => {
      this.requestPayInfo()
    })
  },
  methods: {
    ...mapActions({
      getPayInfo: 'getPayInfo',
      setPayment: 'setPayment',
      getGlobalInfo: 'getGlobalInfo'
    }),
    async requestPayInfo () {
      // 获取卡信息
      await this.getPayInfo({
        ...this.globalParams
      })
      if (Object.keys(this.selectedCard).length === 0) {
        if (this.extraInfoList.length > 0) {
          // 默认选择第一张卡
          this.setPayment(this.extraInfoList[0])
        }
      }
      this.$emit('requestPay', true)
    },
    selectPayment () {
      couponPaymethodPopupCk({
        from: 1
      })
      this.$router.push({
        name: 'payment'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .payment {
    margin-bottom: 67px;
    padding: 0 28px 0 40px;
    height: 54px;
    line-height: 54px;
    display: flex;
    justify-content: space-between;
    color: #333;
    .label {
      font-family: 'Aspira Regular';
      font-size: 32px;
    }
    .select-payment {
      font-family: 'Aspira Regular';
      display: flex;
      align-items: center;
      .has-payment {
        display: flex;
        align-items: center;
      }
      .ic-card {
        width: 87px;
        height: 54px;
        border-radius: 3px;
      }
      .card-num {
        margin-left: 17px;
        font-family: Aspira Medium;
        font-size: 36px;
        color: #333;
      }
      .no-payment {
        display: flex;
        align-items: center;
        font-size: 28px;
        color: #CCC;
      }
      .icon-right {
        margin-left: 8px;
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        background-image: url('~@/assets/images/c/icon-right.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
  }
</style>